import { Injectable } from '@angular/core';
import { HttpService } from '../providers/http.service';
import { AppConfig } from '../app/app.config';
@Injectable()
export class ChatService {
    constructor(
        private httpService: HttpService,
        private AppConfig: AppConfig) { }

    //获取上级用户
    getUpUser() {
        let url = AppConfig.GetProdUrl() + "/Chat/GetUpUser";
        return this.httpService.get(url);
    }
    //获取下级用户
    getSubUsers() {
        let url = AppConfig.GetProdUrl() + '/Chat/GetSubUsers';
        return this.httpService.get(url);

    }

    //获取聊天记录
    getChatMessage(param) {
        let url = AppConfig.GetProdUrl() + "/Chat/GetChatMessage";
        return this.httpService.get(url, param);
    }
    // 获取未读消息
    getUnreadMessageCount() {
        let url = AppConfig.GetProdUrl() + "/Chat/GetChatNewMessageCountByUser";
        return this.httpService.get(url);
    }
    // 发送消息
    sendMessage(param) {
        let url = AppConfig.GetProdUrl() + "/Chat/AddChatMessage";
        return this.httpService.post(url, param);
    }
    // 获取未读消息列表
    getUnreadMessage() {
        let url = AppConfig.GetProdUrl() + "/Chat/GetChatNewMessageCountListByUser";
        return this.httpService.get(url);
    }
    //获取新消息以及下拉获取历史记录
    getNewHistoryMsg(param) {
        let url = AppConfig.GetProdUrl() + "/Chat/GetNewOrOldChatMessages";
        return this.httpService.get(url, param);
    }
    // 标记消息为已读
    setChatMessageIsRead(param) {
        let url = AppConfig.GetProdUrl() + "/Chat/SetChatMessageIsRead?messageId=" + param;
        return this.httpService.get(url, null);
    }
    
    // 获取黑名单设置
    GetChatUserBannedAsync() {
        let url = AppConfig.GetProdUrl() + "/Chat/GetChatUserBannedAsync";
        return this.httpService.get(url);
    }
    // 获取聊天开关
    getChatSetting() {
        let url = AppConfig.GetProdUrl() + "/Chat/GetChatSetting";
        return this.httpService.get(url);
    }
    /**
     * 获取上下级所有用户 (联系人列表)
     */
    getUpUserOrSubUsers(param) {
        let url = AppConfig.GetProdUrl() + '/Chat/GetUpUserOrSubUsers';
        return this.httpService.get(url, param);
    }

    /**
     * 获取下级用户包含下级用户的最新消息数量，和最新消息体
     */
    getSubUsersOrMessage(param) {
        let url = AppConfig.GetProdUrl() + '/Chat/GetSubUsersOrMessage';
        return this.httpService.get(url, param);
    }
}





// WEBPACK FOOTER //
// ./src/services/chat.service.ts